<div mat-dialog-title class="capitalize">
  <span>{{'subscriptions.modal.export.new_export' | translate}}</span>
  <button [mat-dialog-close]="true">
    <i class="fa fa-times"></i>
  </button>
</div>
<form class="createExport" [formGroup]="exportForm">
  <div>
    <div>
      <div class="d-flex form-group">
        <!-- START DATE -->
        <div class="form-group">
          <label>{{'subscriptions.modal.export.start_date' | translate }}</label>
          <dp-date-picker
            class="date"
            #startDatePicker
            formControlName="validityStart"
            [config]="startDatePickerConfig"
            [displayDate]="validityStartDisplayDate"
            mode="day"
            [title]="(f.validityStart.invalid && f.validityStart.dirty) ? 'Date ou heure invalide' : ''"
            name="startDateFilter">
          </dp-date-picker>
        </div>
        <label class="required fix" for="startDate"></label>
      </div>
      @if (f.validityStart.invalid && (f.validityStart.dirty || f.validityStart.touched)) {
        <div class="alert alert-danger up">
          @if (f.validityStart.errors.required) {
            <div>
              {{'error.is_required' | translate}}
            </div>
          }
        </div>
      }
    </div>

    <div>
      <div class="d-flex form-group">
        <!-- END DATE -->
        <div class="form-group">
          <label>{{'subscriptions.modal.export.end_date' | translate}}</label>
          <dp-date-picker
            class="date"
            #endDatePicker
            formControlName="validityEnd"
            [config]="endDatePickerConfig"
            [displayDate]="validityEndDisplayDate"
            mode="day"
            [title]="(f.validityEnd.invalid && f.validityEnd.dirty) ? 'Date ou heure invalide' : ''"
            name="endDateFilter"
            required>
          </dp-date-picker>
        </div>
        <label class="required fix" for="endDate"></label>
      </div>
      @if (f.validityEnd.invalid && (f.validityEnd.dirty || f.validityEnd.touched)) {
        <div class="alert alert-danger up">
          @if (f.validityEnd.errors.required) {
            <div>
              {{'error.is_required' | translate}}
            </div>
          }
        </div>
      }
      @if (exportForm.errors) {
        <div class="alert alert-danger">
          @if (exportForm.errors?.dateEndIsBefore) {
            <div>{{'error.endDateBeforeStartDate' | translate}}</div>
          }
        </div>
      }
    </div>

    <div class="reportType-size">
      <div class="d-flex form-group">
        <select formControlName="reportType" class="form-control"
          [ngClass]="{'border-danger': f.reportType.invalid && (f.reportType.dirty || f.reportType.touched)}" id="reportType">
          <option [ngValue]="null" disabled >{{ 'subscriptions.modal.export.name_repport' | translate }}</option>
          @for (rpt of reportTypes; track rpt) {
            <option [ngValue]="rpt">
              {{ rpt }}
            </option>
          }
        </select>
        <label class="required" for="reportType"></label>
      </div>
      @if (f.reportType.invalid && (f.reportType.dirty || f.reportType.touched)) {
        <div class="alert alert-danger">
          @if (f.reportType.errors.required) {
            <div>
              {{'error.is_required' | translate}}
            </div>
          }
        </div>
      }
    </div>
    <div class="">
      <button class="btn btn--primary" (click)="onSubmit()" style="margin-right: 5px;" >{{'subscriptions.modal.export.create_export' | translate}}</button>
      <button mat-dialog-close class="btn btn--outline-grey-color">{{'action.cancel' | translate}}</button>
    </div>
  </div>
</form>